<template>
  <div class="consultation-form">
    <div>
      <h2 class="title">{{ $t("bepul_consultatsiya") }}</h2>
      <p class="subtitle">{{ $t("subtitle_consul") }}</p>
    </div>

    <!-- NAME -->
    <input
      type="text"
      v-model="form.name"
      :placeholder="$t('name_placeholder')"
      class="input name-input"
      @input="filterName"
      maxlength="25"
    />

    <!-- PROFESSION -->
    <select v-model="form.profession" class="dropdown">
      <option disabled value="">{{ $t("select_question") }}</option>
      <option>{{ $t("web_dasturlash") }}</option>
      <option>{{ $t("dizayn") }}</option>
      <option>{{ $t("SMM") }}</option>
      <option>{{ $t("kiber") }}</option>
      <option>{{ $t("It kids") }}</option>
    </select>

    <!-- CAPTCHA -->
    <div class="capcha">
      <label class="captcha-label">
        {{ form.generateNumber }} + {{ form.generateTwoNumber }} =
      </label>
      <input
        type="text"
        v-model="form.captchaInput"
        class="input"
        placeholder="?"
      />
    </div>

    <!-- PHONE + BUTTON -->
    <div class="Phone_Number">
      <input
        type="tel"
        v-model="form.phone"
        placeholder="+998"
        v-mask="'+998 ## ### ## ##'"
        class="input phone-input"
      />

      <button
        class="submit-btn"
        :disabled="!isFormValid"
        @click="sendToTelegram"
      >
        {{ $t("send__message") }}
      </button>
    </div>

    <!-- CONSENT -->
    <div class="consent-wrapper">
      <label class="custom-checkbox">
        <input type="checkbox" v-model="form.consent" />
        <span class="checkmark"></span>
        {{ $t("personal__info") }} {{ $t("qayta") }} {{ $t("rozi") }}
      </label>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { showSuccess, showError, showWarning } from "@/Utils/Toast";

export default {
  directives: { mask },

  data() {
    return {
      form: {
        name: "",
        phone: "",
        profession: "",
        consent: false,
        generateNumber: 0,
        generateTwoNumber: 0,
        captchaInput: "",
      },
    };
  },

  computed: {
    isFormValid() {
      return (
        this.form.name.trim().length >= 3 &&
        this.form.phone.length > 0 &&
        this.form.profession.trim().length > 0 &&
        this.form.consent
      );
    },
  },

  methods: {
    // CAPTCHA GENERATE
    generateNumberForCaptcha() {
      this.form.generateNumber = Math.floor(Math.random() * 9) + 1;
      this.form.generateTwoNumber = Math.floor(Math.random() * 9) + 1;
    },

    // SEND
    async sendToTelegram() {
      let timeBlock = localStorage.getItem("consultationTime");
      if (timeBlock) {
        let currentTime = new Date().getTime();
        let elapsed = currentTime - parseInt(timeBlock);
        let blockDuration = 15 * 60 * 1000 * 1000 * 1000;
        if (elapsed < blockDuration) {
          showWarning(
            "Siz allaqachon murojaat qildingiz. Iltimos, 15 daqiqadan so‘ng qayta urinib ko‘ring.",
          );
          return;
        }
      }
      if (!this.isFormValid) {
        showWarning("Iltimos, barcha maydonlarni to‘ldiring!");
        return;
      }

      const answer = Number(this.form.captchaInput);
      const correct = this.form.generateNumber + this.form.generateTwoNumber;

      if (!Number.isInteger(answer) || answer !== correct) {
        showError("Captcha noto‘g‘ri kiritildi!");
        this.form.captchaInput = "";
        this.generateNumberForCaptcha();
        return;
      }

      const payload = {
        name: this.form.name,
        phone: this.form.phone,
        profession: this.form.profession,
      };

      try {
        const response = await fetch(
          "https://algowebback-production.up.railway.app/application",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          },
        );

        await response.json();
        showSuccess("Ma’lumot yuborildi!");
        let atTheTime = new Date();
        localStorage.setItem(
          "consultationTime",
          atTheTime.getTime().toString(),
        );
        this.resetForm();
      } catch (error) {
        console.error(error);
        showError("Server bilan aloqa yo‘q!");
      }
    },

    // NAME FILTER
    filterName(event) {
      this.form.name = event.target.value.replace(/[^a-zA-Zа-яА-Яўғқҳʼ ]/g, "");
    },

    // RESET
    resetForm() {
      this.form.name = "";
      this.form.phone = "";
      this.form.profession = "";
      this.form.consent = false;
      this.form.captchaInput = "";
      this.generateNumberForCaptcha();
    },
  },

  mounted() {
    this.generateNumberForCaptcha();
  },
};
</script>

<style>
.consultation-form {
  background: #111;
  color: #fff;
  padding: 26px 30px;
  border-radius: 10px;
  width: 100%;
  display: flex;
  gap: 10px;
  flex-direction: column;
}

.Phone_Number {
  display: flex;
  align-items: center;
  gap: 20px;
}

.consultation-form .title {
  font-size: 2.18rem;
  font-weight: 500;
  font-family: Nohemi;
  color: #f8d800;
}

::placeholder {
  color: rgb(191, 191, 191);
  font-size: 20px;
}
/* CAPTCHA */
.capcha {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 6px;
}

.captcha-label {
  min-width: 100px;
  height: 50px;
  border-radius: 10px;
  background: #1a1a1a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 20px;
  color: #ffcc00;
  letter-spacing: 2px;
  user-select: none;
}

.consultation-form .subtitle {
  font-size: 13px;
  line-height: 16px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 400;
  font-family: Manrope;
  margin-top: 5px;
}

.input {
  width: 100%;
  padding: 16px 21px;
  margin: 8px 0;
  border: 0.5px solid #000;
  border-radius: 10px;
  background: #000;
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  font-family: Manrope;
}

.input:focus {
  border: 0.5px solid #ffcc00;
}

.dropdown {
  width: 100%;
  padding: 12.6px 16px;
  border: #000 solid 0.5px;
  background: #000;
  color: rgba(255, 255, 255, 0.7);
  appearance: none;
  border-radius: 10px;
  background-image: url("@/assets/Images/home_img/arrow-down.png");
  background-repeat: no-repeat;
  background-position: right 20px center;
  font-family: Manrope;
  font-size: 20px;
  cursor: pointer;
}

.submit-btn {
  background: #ffcc00;
  color: rgba(4, 4, 4);
  padding: 13.4px 34px;
  border: none;
  flex: 1;
  border-radius: 10px;
  font-size: 20px;
  font-family: Manrope;
  font-weight: 600;
  width: 100%;
  cursor: pointer;
}

.submit-btn:active {
  background-color: #fff;
  color: #000;
}

.submit-btn:disabled {
  cursor: not-allowed;
}

.submit-btn:disabled:hover,
.submit-btn:disabled:active {
  background: #000;
  color: rgb(191, 191, 191);
}

/* ✅ Consent Checkbox Styling */
.consent-wrapper {
  margin-top: 10px;
}

.custom-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-family: Manrope;
  gap: 10px;
}

.custom-checkbox input {
  display: none;
}

.checkmark {
  width: 18.5px;
  height: 18.5px;
  border-radius: 50%;
  background-color: rgb(47, 47, 47);
  /* border: 1px solid #444; */
  position: relative;
  flex-shrink: 0;
}

.custom-checkbox input:checked + .checkmark {
  background-color: #ffd700;
  background-image: url("@/assets/Images/Vector (3).svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 60%;
}
@media (max-width: 480px) {
  .consultation-form {
    padding: 25px;
    margin-bottom: 20px;
  }
  .input,
  .dropdown,
  .name-input {
    font-size: 14px !important;
  }
  .consultation-form .title {
    font-size: 28px;
  }
}
</style>
